module.exports = __webpack_public_path__ + "static/media/matches-icon.a323ec2b.png";